import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8de7783b91b8a56/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/node_modules/next/dist/client/link.js");
